import React from 'react';
import DataTableWidget from 'common/components/DataTableWidget';
import PageContainer from 'common/components/PageContainer';
import styles from './styles.module.scss';

const columns = [
  {
    Header: 'מספר דוח',
    accessor: 'firmShumaID', // accessor is the "key" in the data
  },
  {
    Header: ['תאריך יצירה', 'סטטוס'],
    accessor: 'createTime',
  },
  {
    Header: 'כתובת',
    accessor: 'fullAddress',
  },
  {
    Header: 'גוש / חלקה',
    accessor: 'gushHelka',
  },
  {
    Header: ['סוג דוח', 'סוג הנכס'],
    accessor: 'shumaAndPropertyTypes',
  },
  {
    Header: 'לקוחות',
    accessor: 'customers',
  },
  {
    Header: ' ',
    accessor: 'actions',
  },
];

const InspectedListPage = ({
                             list,
                             page,
                             setPage,
                             getListByUser,
                             totalPages,
                             totalResultCount
                           }) => {
  return (
    <PageContainer>
      <DataTableWidget
        title={'מאגר הדוחות שלי'}
        module={'InspectedList'}
        getListHandler={getListByUser}
        data={list}
        columns={columns}
        page={page}
        setPage={setPage}
        totalPages={totalPages}
        totalResults={totalResultCount}
        customClassNames={{
          headerCell: styles.customHeaderCell,
          row: styles.customRow
        }}
      />
    </PageContainer>
  );
};

export default InspectedListPage;